


















































































import { defineComponent, PropType, ref, toRefs } from '@vue/composition-api';
import { HelpCircleIcon } from 'tdesign-icons-vue';
import { debounce } from 'lodash';
import { MessagePlugin } from 'tdesign-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import { formatSize } from '@/renderer/scripts/utils/tools';
import { SyncConflictItemData } from '@/renderer/views/desktop/FileManagement/FileSync/composition/FileSyncUIDefine';
import ConflictData from '@/workerProcessRenderer/scripts/CoSyncEngine/common/ConflictData';
import {
  CmdFromRenderer,
  CmdTypeFromRender,
} from '@/renderer/scripts/CoSync/SyncCenter/ServiceMgr/ServiceCommand/CmdFromRenderer';
import ipc, { IpcEvents } from '@/renderer/scripts/utils/ipc';
import tips from '@/renderer/scripts/utils/tips';
import dynamicOpenHandler from '@/renderer/components/drawer/Dynamic/composition/dynamicOpenHandler';
import smh from '@/renderer/scripts/smh';
import useSyncTaskControlHandler from '@/renderer/views/desktop/FileManagement/FileSync/composition/SyncTaskControlHandler';

import {
  ClickAreaInConflictDrawer,
  CoSyncReporter,
} from '@/renderer/views/desktop/FileManagement/FileSync/composition/CoSyncReporter';
import { IS_PC_IN_WIN } from '@/common/constant';

export default defineComponent({
  components: {
    HelpCircleIcon,
  },
  props: {
    conflictListData: {
      type: Array as PropType<SyncConflictItemData[]>,
      require: true,
      default: [],
    },
  },
  setup(props, context) {
    const { methods: taskControlMethods } = useSyncTaskControlHandler();

    const { conflictListData } = toRefs(props);

    dynamicOpenHandler();
    const GetTooltips = (SyncStrategy: string) => {
      if (SyncStrategy === 'local_to_cloud') {
        return `${i18n_t('上传同步')}<br />&bull; ${i18n_t(
          '覆盖云端：本地版本上传为云端新版本，原云端版本作为历史版本（若历史版本功能已开启）',
        )}<br />&bull; ${i18n_t('全部保留：本地文件自动重命名后上传到云端，作为一个独立的新文件')}`;
      }
      if (SyncStrategy === 'cloud_to_local') {
        return `${i18n_t('下载同步')}<br />&bull; ${i18n_t('覆盖本地：云端版本覆盖本地版本')}<br />&bull; ${i18n_t(
          '全部保留：自动更新后另存为本地文件（在文件名里面自动增加序号“1”，然后云端版本覆盖本地版本）',
        )}`;
      }
      return `${i18n_t('双向同步')}<br />&bull; ${i18n_t('覆盖本地：云端版本覆盖本地版本')}<br />&bull; ${i18n_t(
        '覆盖云端：本地版本上传为云端新版本，原云端版本作为历史版本（若历史版本功能已开启）',
      )}<br />&bull; ${i18n_t(
        '全部保留：本地文件自动重命名后上传到云端，作为一个独立的新文件。同时云端文件覆盖本地文件。',
      )}`;
    };

    const formatFileSize = (fileSize: number) => {
      const sizeInfo = formatSize(fileSize);
      return `${sizeInfo.size}${sizeInfo.unit}`;
    };

    const isBtnClicked = ref(false); // 用于在进程通信时disable按钮

    const onLocalPreferenceBtnClick = async (data: SyncConflictItemData) => {
      isBtnClicked.value = true;
      const conflictData = new ConflictData();
      conflictData.fromDataObj(data.conflictDataObj);
      conflictData.chooseLocalPreference();
      await sendResultToWorker(data.syncId, conflictData);
      isBtnClicked.value = false;
      CoSyncReporter.getInstance().reportConflictDrawerClick(ClickAreaInConflictDrawer.ConflictResolveLocalPrefer);
    };

    const onRemotePreferenceBtnClick = async (data: SyncConflictItemData) => {
      isBtnClicked.value = true;
      const conflictData = new ConflictData();
      conflictData.fromDataObj(data.conflictDataObj);
      conflictData.chooseRemotePreference();
      await sendResultToWorker(data.syncId, conflictData);
      isBtnClicked.value = false;
      CoSyncReporter.getInstance().reportConflictDrawerClick(ClickAreaInConflictDrawer.ConflictResolveRemotePrefer);
    };

    const onKeepBothBtnClick = async (data: SyncConflictItemData) => {
      isBtnClicked.value = true;
      const conflictData = new ConflictData();
      conflictData.fromDataObj(data.conflictDataObj);
      conflictData.chooseKeepBoth();
      await sendResultToWorker(data.syncId, conflictData);
      isBtnClicked.value = false;
      CoSyncReporter.getInstance().reportConflictDrawerClick(ClickAreaInConflictDrawer.ConflictResolveKeepBoth);
    };

    const sendResultToWorker = async (syncId: number, data: ConflictData) => {
      const cmd: CmdFromRenderer = {
        cmdType: CmdTypeFromRender.CONFLICT_RESOLVE,
        param: data.toDataObj(),
      };
      await taskControlMethods.applyNoneReturnCommand(syncId, cmd);
    };

    const pathDiv = IS_PC_IN_WIN ? '\\' : '/';

    const getFileOrFolderName = (filePath: string) => {
      return filePath.split('/').at(-1);
    };

    const getParentFolderPath = (filePath: string, platformDiv: boolean) => {
      const filePathArray = filePath.split(platformDiv ? pathDiv : '/');
      filePathArray.pop();
      return filePathArray.join(platformDiv ? pathDiv : '/');
    };

    const openLocalFolder = async (syncConflictItem: SyncConflictItemData) => {
      const localPath = getLocalFullPath(syncConflictItem);
      const isOpen = await ipc.invoke(IpcEvents.INVOKE_OPERATE_MAIN_LISTENER, {
        event: 'openPath',
        params: { path: localPath },
      });
      if (!isOpen) {
        tips.error(i18n_t('本地文件已被移动、删除或重命名，无法打开'));
      }
      CoSyncReporter.getInstance().reportConflictDrawerClick(ClickAreaInConflictDrawer.OpenLocalFolder);
    };

    const innerOpenRemoteFolder = async (syncConflictItem: SyncConflictItemData) => {
      const msg = MessagePlugin.loading(i18n_t('正在跳转'));
      const options = {
        path: getParentFolderPath(getRemoteFullPath(syncConflictItem), false),
        spaceId: syncConflictItem.spaceId,
        spaceOrgId: syncConflictItem.spaceOrgId,
      };
      try {
        const { data } = await smh.userAPI.getDirectoryOrFileInfo(options);
        ipc.emit(ipc.RENDERER_EVENTS_MAP.DRAWER_DYNAMIC_OPEN, {
          ...data,
          toObjectPath: data.path.join('/'),
          spaceId: syncConflictItem.spaceId,
          orgId: syncConflictItem.spaceOrgId,
        });
      } catch (error: any) {
        tips.error(error);
      }
      MessagePlugin.close(msg);
      CoSyncReporter.getInstance().reportConflictDrawerClick(ClickAreaInConflictDrawer.OpenRemoteFolder);
    };

    const openRemoteFolder = debounce(innerOpenRemoteFolder, 1000, { leading: true, trailing: false });

    const getLocalFullPath = (syncConflictItem: SyncConflictItemData) => {
      const localPath = syncConflictItem.conflictDataObj.localItem.path;
      const localPathArray = localPath.split('/');
      localPathArray.shift();
      return `${syncConflictItem.localRootPath}${pathDiv}${localPathArray.join(pathDiv)}`;
    };

    const getRemoteFullPath = (syncConflictItem: SyncConflictItemData) => {
      const remotePath = syncConflictItem.conflictDataObj.remoteItem.path;
      const remotePathArray = remotePath.split('/');
      remotePathArray.shift();
      return `${syncConflictItem.remoteRootPath}/${remotePathArray.join('/')}`;
    };

    return {
      innerConflictListData: conflictListData,
      GetTooltips,
      formatFileSize,
      isBtnClicked,
      onLocalPreferenceBtnClick,
      onRemotePreferenceBtnClick,
      onKeepBothBtnClick,
      getFileOrFolderName,
      openLocalFolder,
      openRemoteFolder,
    };
  },
});
